import { type ImageFormats } from '@components/helpers/imagesImports';

type ResourceTypeText =
  | 'wood'
  | 'cotton'
  | 'bulk'
  | 'iron'
  | 'oil'
  | 'precious';

type ResourceCategory = {
  background: ImageFormats;
  build: ImageFormats;
  mine: ImageFormats;
  icon: ImageFormats;
};

type ResourceTypeImages = Record<ResourceTypeText, ResourceCategory>;

const resourceTypesArray: ResourceTypeText[] = [
  'wood',
  'cotton',
  'bulk',
  'iron',
  'oil',
  'precious',
];

export {
  type ResourceCategory,
  type ResourceTypeImages,
  resourceTypesArray,
  type ResourceTypeText,
};
